export default {

    init() {
		document.addEventListener("DOMContentLoaded", this.bindEvents);
    },

    bindEvents() {
        $('[data-dropdown]').on('click', function(e) {
			e.preventDefault();
            Dropdown.toggle(this);
        });

		const closeEvent = new CustomEvent('close.dropdown', { bubbles: true });
		const openEvent = new CustomEvent('close.dropdown', { bubbles: true });
		Dropdown.CLOSE_EVENT = closeEvent;
		Dropdown.OPEN_EVENT = openEvent;
    },

    toggle(elem) {
		let $button = $(elem);
		let $panel = $('#' + $button.attr('aria-controls'));
		let isActive = $panel.hasClass('is-active');

		if(!$panel.length) {
			return;
		}

		if(!isActive) {
			Dropdown.close();
			$button.attr('aria-expanded', 'true');
			$panel.addClass('is-active');
			elem.parentNode.classList.add('is-active');
			Dropdown.ACTIVE_MENU = elem.parentNode;
			document.addEventListener('click', Dropdown.clickOutside);
			window.addEventListener('keyup', Dropdown.keyListener, false);
		} else {
			$button.attr('aria-expanded', 'false');
			$panel.removeClass('is-active');
			elem.parentNode.classList.remove('is-active');
			Dropdown.ACTIVE_MENU = null;
			document.removeEventListener('click', Dropdown.clickOutside);
			window.removeEventListener('keyup', Dropdown.keyListener, false);
			elem.dispatchEvent(Dropdown.CLOSE_EVENT);
		}
    },

	close() {
		if(Dropdown.ACTIVE_MENU && Dropdown.ACTIVE_MENU.querySelector('[data-dropdown]')) {
			let elem = Dropdown.ACTIVE_MENU.querySelector('[data-dropdown]');
			Dropdown.toggle(elem);
		}
	},

	clickOutside(e) {
		if(!Dropdown.ACTIVE_MENU.contains(e.target)) {
			Dropdown.close();
		}
	},

	keyListener(e) {
		const isEsc = e.keyCode === 27;

		if(isEsc) {
			Dropdown.close();
		}
	},

};